import { render } from "./AddTutarial.vue?vue&type=template&id=0be5f51e&scoped=true"
import script from "./AddTutarial.vue?vue&type=script&lang=js"
export * from "./AddTutarial.vue?vue&type=script&lang=js"

import "./AddTutarial.vue?vue&type=style&index=0&id=0be5f51e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be5f51e"]])

export default __exports__